// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".viewable-facilities-waiter-list-tab[data-v-75e9fd96]{width:100%}.viewable-facilities-waiter-list-tab .advanced-setting-reset-btn[data-v-75e9fd96]{height:32px!important;font-size:16px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
